import { ambassadorInfoCRUDActions as AmbassadorInfoAction } from '../actions/AmbassadorInfoCRUDActions';
import Actions from '../actions/actions';
import { setBusy, setUnBusy } from './common/commonReducers';
import { AmbassadorInfoState } from '../interfaces/ambassadorInfo';

const initialState: AmbassadorInfoState = {
  busy: false,
  entity: undefined,
};

export function ambassadorInfo(state = initialState, action) {
  switch (action.type) {
    case AmbassadorInfoAction.busyAction:
      return setBusy(state);
    case AmbassadorInfoAction.retrievedAction: {
      return {
        ...state,
        entity: action.entity,
        busy: false,
      };
    }
    case AmbassadorInfoAction.updateAction: {
      return {
        ...state,
        busy: false,
        entity: action.entity,
      };
    }
    case AmbassadorInfoAction.unbusyAction:
      return setUnBusy(state);
    case Actions.RESET:
      return initialState;
    default:
      return state;
  }
}
